import React from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearUser } from '../redux/slices/userSlice';

const isAuthenticated = () => {
  return !!localStorage.getItem('access_token');
};

const ProtectedRoute = ({ children, allowedRoles }) => {
  const dispatch = useDispatch();
  
  const { role, sessionCount, errorRes, status } = useSelector((state) => state.user);
  

  if (!isAuthenticated()) {
    return <Navigate to="/SignIn" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role) && role) {
    return <Navigate to="/forbidden" replace />;
  }

  if (role === 'user' && sessionCount === 0) {
    return <Navigate to="/password-change" replace />;
  }
  if(status == 403){
    return <Navigate to="/authentication" replace />;
  }

  if (errorRes === 401) {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    dispatch(clearUser());
    return <Navigate to="/SignIn" replace />;
  }

  return children;
};

export default ProtectedRoute;
